import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetPreviewModalComponent } from '../views/shared/modals/asset-preview-modal/asset-preview-modal.component';
import { ModalUtils } from '../utils/modal-utils';
import { exists } from '../functions/exists';
import { Asset } from '../models/image/dto/asset';
import { AssetGroup } from '../models/product/dto/asset-group';

export class ModalAssetPreview {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    displayGroupId: string,
    libraryTypeName: string,
    asset: Asset,
    canDelete: boolean,
    isDisabled: boolean,
    isBrandAssetGroup: boolean,
    onClose?: (ags: AssetGroup[]) => void
  ) {
    ngZone.run(() => {
      const modalRef = ngbModal.open(AssetPreviewModalComponent, ModalUtils.assetPreviewModalOptions(injector));
      const compInstance = modalRef.componentInstance as AssetPreviewModalComponent;
      compInstance.setAssetPreviewInfo(
        displayGroupId,
        libraryTypeName,
        asset,
        canDelete,
        isDisabled,
        isBrandAssetGroup
      );
      modalRef.result
        .then(updatedAssetGroups => {
          if (exists(updatedAssetGroups)) {
            onClose?.(updatedAssetGroups);
          }
        })
        .catch(() => {});
    });
  }
}
